var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1913 4.65316L12.6387 1.07957C12.5877 1.02831 12.5202 1.00015 12.4481 1.00015C12.376 1.00015 12.3088 1.02831 12.2579 1.07958L10.1531 3.197L10.1506 3.20458L10.1086 3.24177L1.9793 11.4201C1.94162 11.458 1.91615 11.5057 1.90574 11.5576L1.00581 16.0375C0.987873 16.1267 1.01551 16.218 1.07939 16.2826C1.13035 16.3336 1.19782 16.3617 1.26996 16.3617C1.2879 16.3617 1.30548 16.3599 1.32199 16.3566L5.77596 15.4507C5.82835 15.4403 5.87536 15.4146 5.91269 15.3771L16.1913 5.0362C16.2422 4.98529 16.2699 4.91706 16.2699 4.8445C16.2699 4.77193 16.2419 4.70406 16.1913 4.65316ZM5.58897 14.9363L1.61338 15.7451L2.41678 11.7454L3.59027 10.5648L6.76245 13.7561L5.58897 14.9363ZM7.14285 13.373L3.97066 10.1821L10.3043 3.81036L13.4761 7.00129L7.14285 13.373ZM13.8572 6.61824L10.6854 3.42731L12.4481 1.65395L15.6203 4.84488L13.8572 6.61824Z",
    fill: "#405BFF",
    stroke: "#405BFF",
    strokeWidth: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPen);
export default __webpack_public_path__ + "static/media/edit-pen.715151535deb6553c247383ad5cf4c14.svg";
export { ForwardRef as ReactComponent };